/* Mindset Media Group · Header Drawer / Sticky Lock v3
   Native Dawn HeaderDrawer remains the disclosure owner.
   Critical iOS/WebKit repair: do not switch the sticky header to fixed during
   the same click turn that toggles the native <details>. The visual viewport
   lock is applied on the next animation frame, after the disclosure state is
   established, and is removed synchronously on close. */
(function () {
  'use strict';

  var VISUAL_LOCK_CLASS = 'mmg-drawer-visual-lock';

  function normalizeHeader(header) {
    if (!header) return;
    header.classList.add('shopify-section-header-sticky');
    header.classList.remove('shopify-section-header-hidden');

    var height = header.offsetHeight;
    if (height > 0) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }

    header.getBoundingClientRect();
  }

  function installStickyHideLock() {
    var StickyHeader = customElements.get('sticky-header');
    if (!StickyHeader || !StickyHeader.prototype) return;

    var prototype = StickyHeader.prototype;
    if (prototype.__mmgHeaderDrawerStickyLockV3) return;

    var nativeHide = prototype.hide;
    if (typeof nativeHide !== 'function') return;

    prototype.hide = function () {
      if (this.header && this.header.classList.contains('menu-open')) {
        normalizeHeader(this.header);
        return;
      }

      return nativeHide.apply(this, arguments);
    };

    Object.defineProperty(prototype, '__mmgHeaderDrawerStickyLockV3', {
      value: true,
      configurable: false,
      enumerable: false,
      writable: false
    });
  }

  function installHeaderDrawerLock() {
    var HeaderDrawer = customElements.get('header-drawer');
    if (!HeaderDrawer || !HeaderDrawer.prototype) return;

    var prototype = HeaderDrawer.prototype;
    if (prototype.__mmgHeaderDrawerVisualLockV3) return;

    var nativeOpen = prototype.openMenuDrawer;
    var nativeClose = prototype.closeMenuDrawer;
    if (typeof nativeOpen !== 'function' || typeof nativeClose !== 'function') return;

    prototype.openMenuDrawer = function (summaryElement) {
      var header = this.header || document.querySelector('.section-header');
      normalizeHeader(header);

      var result = nativeOpen.apply(this, arguments);

      window.requestAnimationFrame(function () {
        if (!header) return;
        var details = document.getElementById('Details-menu-drawer-container');
        if (!details || !details.hasAttribute('open')) return;

        normalizeHeader(header);
        header.classList.add(VISUAL_LOCK_CLASS);

        var drawer = document.getElementById('menu-drawer');
        if (drawer) {
          drawer.getBoundingClientRect();
        }
      });

      return result;
    };

    prototype.closeMenuDrawer = function () {
      var header = this.header || document.querySelector('.section-header');
      if (header) header.classList.remove(VISUAL_LOCK_CLASS);
      return nativeClose.apply(this, arguments);
    };

    Object.defineProperty(prototype, '__mmgHeaderDrawerVisualLockV3', {
      value: true,
      configurable: false,
      enumerable: false,
      writable: false
    });
  }

  function install() {
    installStickyHideLock();
    installHeaderDrawerLock();
  }

  if (customElements.get('sticky-header') && customElements.get('header-drawer')) {
    install();
    return;
  }

  if (customElements.whenDefined) {
    Promise.all([
      customElements.whenDefined('sticky-header'),
      customElements.whenDefined('header-drawer')
    ]).then(install);
  }
})();
